import React from 'react';
import { observer } from 'mobx-react';
import { ImageBlockContent, SlideshowBlockContent, VideoBlockContent } from '../../../../commonv3/types/block';
import { VideoBlockContentPane } from './VideoBlockContentPane';
import { ImageBlockContentPane } from './ImageBlockContentPane';
import { SlideshowBlockContentPane } from './SlideshowBlockContentPane';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3MembershipPlanKey } from '../../../../mainv2/types/user';
import { DummyImageBlockContentPane } from './DummyImageBlockContentPane';
import { CoachSkillType } from '../../../types/coachSkillCertifications';
import { CourseCategoryShowView, COURSE_CATEGORY } from '../../../types/courseCategories';
import {
  isAllowedToWatchBrandingVideos,
  isAllowedToWatchDesignVideos,
  isAllowedToWatchMarketingVideos,
  isAllowedToWatchWritingVideos,
} from './VideoPermissions';

type Props = (
  | {
      blockType: 'video';
      content: VideoBlockContent;
    }
  | {
      blockType: 'image';
      content: ImageBlockContent;
    }
  | {
      blockType: 'slideshow';
      content: SlideshowBlockContent;
    }
) & {
  courseCategory?: CourseCategoryShowView;
  currentUserSkillTypes: CoachSkillType[];
};

export const BlockContentPane = observer(({ blockType, content, courseCategory, currentUserSkillTypes }: Props) => {
  const user = GlobalStatesV3.currentUser.currentUser;

  switch (blockType) {
    case 'video':
      if (user.membership_plan_keys.includes(V3MembershipPlanKey.PLANNER)) {
        switch (courseCategory?.name) {
          case COURSE_CATEGORY.Design:
            if (isAllowedToWatchDesignVideos(currentUserSkillTypes)) return <VideoBlockContentPane content={content} />;
            break;
          case COURSE_CATEGORY.Writing:
            // prettier-ignore
            if (isAllowedToWatchWritingVideos(currentUserSkillTypes)) return <VideoBlockContentPane content={content} />;
            break;
          case COURSE_CATEGORY.Marketing:
            // prettier-ignore
            if (isAllowedToWatchMarketingVideos(currentUserSkillTypes)) return <VideoBlockContentPane content={content} />;
            break;
          case COURSE_CATEGORY.Branding:
            // prettier-ignore
            if (isAllowedToWatchBrandingVideos(currentUserSkillTypes)) return <VideoBlockContentPane content={content} />;
            break;
        }
        return <DummyImageBlockContentPane />;
      } else {
        return <VideoBlockContentPane content={content} />;
      }
    case 'image':
      return <ImageBlockContentPane content={content} />;
    case 'slideshow':
      return <SlideshowBlockContentPane content={content} />;
  }
});
